module.exports = __webpack_public_path__ + "img/foot-channel5.e8a54239.png";